import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookMarked, Loader2, Trash2, ShieldCheck, Layers } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { confirmAsync } from "./ConfirmDialog";

// Saved workflow templates: one click → a new draft with the same steps (goal = typed goal or the template's).
export function WorkflowTemplates({ goal }) {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/workflow-templates").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  const use = async (t) => {
    setBusy(t.id);
    try { const r = await api.post(`/workflow-templates/${t.id}/use`, { goal: goal.trim() || null }); toast.success(`Draft dibuat dari template «${t.name}»`); nav(`/workspace/${r.data.id}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal memakai template"); setBusy(""); }
  };
  const del = async (e, t) => {
    e.stopPropagation();
    if (!await confirmAsync(`Hapus template «${t.name}»?`)) return;
    try { await api.delete(`/workflow-templates/${t.id}`); toast.success("Template dihapus"); load(); } catch { toast.error("Gagal menghapus"); }
  };
  return (
    <div className="mt-6" data-testid="workflow-templates">
      <div className="mb-2 flex items-center gap-2"><BookMarked size={15} className="text-[#7C3AED]" /><h2 className="text-sm font-semibold uppercase tracking-wider text-slate-500">Template workflow</h2><span className="text-[11px] text-slate-400">Klik untuk membuat draft dengan langkah yang sama{goal.trim() ? " untuk tujuan yang Anda ketik" : ""}</span></div>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((t) => (
          <button key={t.id} onClick={() => use(t)} disabled={!!busy} data-testid={`wf-template-${t.id}`} className="aivora-card group relative p-3.5 text-left transition hover:border-[#7C3AED]/50 disabled:opacity-60">
            <p className="truncate pr-6 text-sm font-bold text-slate-900">{t.name}</p>
            <p className="mt-0.5 line-clamp-2 text-xs text-slate-500">{t.goal}</p>
            <p className="mt-2 flex flex-wrap items-center gap-x-2 text-[11px] text-slate-500">
              <span>{t.steps.length} langkah</span>
              {t.steps.some((s) => s.needs_approval) && <span className="flex items-center gap-0.5 text-amber-600"><ShieldCheck size={11} /> {t.steps.filter((s) => s.needs_approval).length} gate</span>}
              {t.method === "batch" && <span className="flex items-center gap-0.5 text-emerald-700"><Layers size={11} /> batch</span>}
              {t.uses > 0 && <span>{t.uses}× dipakai</span>}
            </p>
            {busy === t.id ? <Loader2 size={14} className="absolute right-3 top-3 animate-spin text-[#7C3AED]" /> : <span role="button" tabIndex={0} onClick={(e) => del(e, t)} data-testid={`wf-template-delete-${t.id}`} className="absolute right-2.5 top-2.5 rounded p-1 text-slate-300 opacity-0 transition hover:bg-red-50 hover:text-[#EF4444] group-hover:opacity-100"><Trash2 size={13} /></span>}
          </button>
        ))}
      </div>
    </div>
  );
}
